import { PROJECT_TEMPLATE_REDUCER_KEYS as KEYS } from '../reducers/projectTemplatesReducerKeys'

export const customProjectTemplatesMapSelector = state => state.getIn([KEYS.REDUCER, KEYS.CUSTOM])
export const customProjectTemplateSelector = (state, id) => state.getIn([KEYS.REDUCER, KEYS.CUSTOM, id])

export const publicProjectTemplateCategoriesSelector = state => state.getIn([KEYS.REDUCER, KEYS.PUBLIC_CATEGORIES])
export const publicProjectTemplatesMapSelector = state => state.getIn([KEYS.REDUCER, KEYS.PUBLIC])
export const publicProjectTemplateSelector = (state, id) => state.getIn([KEYS.REDUCER, KEYS.PUBLIC, id])
